import toast from 'react-hot-toast';

// Custom error class for API errors
export class ApiError extends Error {
  constructor(
    public status: number,
    public message: string,
    public data?: unknown
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Handle API errors and display appropriate toast messages
 * @param error - The error object from API calls
 * @param fallbackMessage - Fallback message if error doesn't have a specific message
 */
export const handleApiError = (
  error: unknown,
  fallbackMessage: string = 'An error occurred'
): void => {
  // Handle ApiError specifically to get the proper error message
  if (error && typeof error === 'object' && 'message' in error) {
    toast.error(error.message as string);
  } else {
    toast.error(fallbackMessage);
  }
};

/**
 * Check if an error is an ApiError instance
 * @param error - The error object to check
 * @returns true if it's an ApiError, false otherwise
 */
export const isApiError = (error: unknown): error is ApiError => {
  return error instanceof ApiError;
};
